import { render } from "./AppPanelMenu.vue?vue&type=template&id=c609c658"
import script from "./AppPanelMenu.vue?vue&type=script&lang=js"
export * from "./AppPanelMenu.vue?vue&type=script&lang=js"

import "./AppPanelMenu.vue?vue&type=style&index=0&id=c609c658&lang=css"

import exportComponent from "/data/www/shoptok-analytics/frontend/live/live_225/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__